import React from "react";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";

const DropdownField = ({
  field,
  value,
  isOpen,
  onToggle,
  onChange,
  createRefCallback,
  formData,
}) => {
  // Check conditional display
  if (field.conditional && !field.conditional(formData)) {
    return null;
  }

  return (
    <div key={field.key} className="mb-4 sm:mb-5">
      <label className="block text-gray-700 font-medium mb-2 text-sm sm:text-base">
        {field.label}
        {field.required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div
        className="relative overflow-visible"
        ref={createRefCallback(field.key)}
      >
        <button
          type="button"
          className={`w-full p-3 sm:p-4 text-left bg-white border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 min-h-[48px] touch-manipulation text-sm sm:text-base ${
            value ? "text-gray-900" : "text-gray-500"
          } ${
            isOpen
              ? "border-blue-500 ring-2 ring-blue-500"
              : "border-gray-300 hover:border-gray-400"
          }`}
          onClick={(e) => onToggle(field.key, e)}
        >
          <span className="block truncate">
            {value || `Chọn ${field.label.toLowerCase()}`}
          </span>
          <span className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            {isOpen ? (
              <FiChevronUp className="h-5 w-5 sm:h-4 sm:w-4 text-gray-400" />
            ) : (
              <FiChevronDown className="h-5 w-5 sm:h-4 sm:w-4 text-gray-400" />
            )}
          </span>
        </button>

        {isOpen && (
          <div
            className="absolute z-50 mt-2 w-full bg-white border border-gray-300 rounded-lg shadow-xl max-h-64 sm:max-h-60 overflow-auto"
            style={{
              top: "100%",
              left: 0,
              right: 0,
            }}
          >
            {field.options.map((option) => (
              <div
                key={option}
                className={`cursor-pointer select-none relative py-3 sm:py-2 pl-4 sm:pl-3 pr-10 sm:pr-9 hover:bg-blue-50 active:bg-blue-100 transition-colors duration-150 text-sm sm:text-base min-h-[48px] sm:min-h-auto flex items-center touch-manipulation ${
                  value === option
                    ? "bg-blue-100 text-blue-900"
                    : "text-gray-900"
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onChange(field.key, option);
                }}
              >
                <span className="block truncate">{option}</span>
                {value === option && (
                  <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-blue-600 font-semibold">
                    ✓
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DropdownField;
